import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  backdrop: {
    zIndex: 10,
    color: "#fff",
  },
  card: {
    width: "90vw",
    maxWidth: "600px",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  content_wrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
  },
  top_section: {
    padding: "20px 20px 10px 20px",
    flexShrink: 0,
  },
  bottom_section: {
    padding: "10px 20px 20px 20px",
    flexShrink: 0,
    borderTop: "1px solid #e0e0e0",
    backgroundColor: "#fafafa",
  },
  button_row: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-end",
  },
  select_btn: {
    padding: "8px 16px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: "#f5f5f5",
    cursor: "pointer",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  },
  items_container: {
    flex: "1 1 auto",
    overflowY: "auto",
    overflowX: "hidden",
    border: "1px solid #e0e0e0",
    borderRadius: "4px",
    padding: "10px",
    margin: "0 20px",
    minHeight: "150px",
  },
  form_control: {
    width: "100%",
    margin: "5px 0 !important",
    border: "1px solid #f0f0f0",
    borderRadius: "4px",
    padding: "5px 10px",
    "&:hover": {
      backgroundColor: "#f9f9f9",
    },
  },
  item_label: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    paddingRight: "10px",
  },
  item_name: {
    flex: 1,
    fontSize: "15px",
    fontWeight: "500",
  },
  item_qty: {
    fontSize: "14px",
    color: "#666",
    marginLeft: "10px",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  selected_count: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  },
});

export default useStyles;
